import { FormControl, InputLabel, TextField } from "@mui/material";
import React from "react";

interface TheInputProps {
  title: string;
  onChange?: () => void;
  value?: string;
  placeholder: string;
  type: "text" | "number" | "email" | "password";
}

const ReUseAbleTextField = ({
  title,
  onChange,
  value,
  placeholder,
  type,
}: TheInputProps) => {
  return (
    <FormControl variant="standard" fullWidth sx={{ mb: "12px" }}>
      <InputLabel shrink sx={{ fontWeight: 800 }}>
        {title}
      </InputLabel>
      <TextField
        placeholder={placeholder}
        type={type}
        variant="standard"
        value={value}
        InputProps={{ disableUnderline: true }}
        sx={{
          bgcolor: "transparent",
          borderRadius: "10px",
          borderStyle: "none",
          border: "1px solid #D0D5DD",
          mt: 2.5,
          py: 1,
          px: 2,
        }}
        onChange={onChange}
      />
    </FormControl>
  );
};

export default ReUseAbleTextField;
